import React from 'react'
import './navbar.css'

function Navbar(){
    return(
        <div className='navbar'>
            <div className='navbar_logo'><img src="./navbar_logo.png"></img></div>
        </div>
    )
}

export default Navbar